import React from "react";


export default function StartHere () {
    return(
        <div>Start Here</div>
    )
}